export const EVENT_CREATE = `event.create`
export const EVENT_DELETE = `event.delete`
export const EVENT_UPDATE = `event.update`
export const EVENTS_CHANGE_STATUS = `event.changeStatus`

export const EVENT_TYPE_CREATE = `eventType.create`
export const EVENT_TYPE_DELETE = `eventType.delete`
export const EVENT_TYPE_UPDATE = `eventType.update`

export const PLAN_CONSTRAINTS_UPDATE = `plan.constraints.update`

export const PLAN_CREATE = `plan.create`
export const PLAN_DELETE = `plan.delete`
export const PLAN_UPDATE = `plan.update`

export const PLAN_LOCK = `plan.lock`
export const PLAN_UNLOCK = `plan.unlock`

export const PLAN_EVENT_TYPES_UPDATE = `plan.eventTypes.update`

export const PLAN_REPORT_TEMPLATES_UPDATE = `plan.reportTemplates.update`

export const PLAN_RESOURCES_UPDATE = `plan.resources.update`

export const PLAN_TYPE_CREATE = `planType.create`
export const PLAN_TYPE_DELETE = `planType.delete`
export const PLAN_TYPE_UPDATE = `planType.update`

export const RESOURCE_CREATE = `resource.create`
export const RESOURCE_DELETE = `resource.delete`
export const RESOURCE_UPDATE = `resource.update`

export const RESOURCE_PROJECTION_CREATE = `resource.projection.create`
export const RESOURCE_PROJECTION_DELETE = `resource.projection.delete`
export const RESOURCE_PROJECTION_UPDATE = `resource.projection.update`

export const RESOURCE_TYPE_CREATE = `resourceType.create`
export const RESOURCE_TYPE_DELETE = `resourceType.delete`
export const RESOURCE_TYPE_UPDATE = `resourceType.update`
